import { API } from "@/services/api";
import { reportEndpoints } from "@/constant/endpoints";
import { buildQueryString } from "@/utils/common.utils";
import { OrganizationReport, OrganizationReportParams, ReportsSummary, ReportsSummaryParams } from "@/types/reports.types";

export const getReportsSummaryService = async (
  params: ReportsSummaryParams = {}
): Promise<ReportsSummary> => {
  const response = await API.Get<ReportsSummary>(`${reportEndpoints.summary}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};

export const getOrganizationReportService = async (
  params: OrganizationReportParams = {}
): Promise<OrganizationReport> => {
  const response = await API.Get<OrganizationReport>(`${reportEndpoints.organization}${buildQueryString(params)}`);
  if (response.data) return response.data;
  throw new Error(response.message);
};
